import { useQuery } from '@tanstack/react-query';
import type { User, Processo } from '../../../../models';
import { apiService } from '../../../demands/services/api';
import type { UserOption, SelectOption } from '../../../../components/Select/types';

interface UseDemandFiltersQueryOptions {
  enabled?: boolean;
}

interface UseDemandFiltersQueryResult {
  userOptions: UserOption[];
  processoOptions: SelectOption[];
}

const buildUserOptions = (users: User[]): UserOption[] =>
  users.map((user) => ({
    value: user.id,
    label: user.name,
    email: user.email,
    name: user.name,
  }));

const buildProcessoOptions = (processos: Processo[]): SelectOption[] => [
  // Adiciona opção "Todos os processos" como primeira opção
  { value: '', label: 'Todos os processos' },
  ...processos.map((processo) => ({
    value: processo.id,
    label: processo.nome_processo,
  })),
];

export const useDemandFiltersQuery = (options: UseDemandFiltersQueryOptions = {}) => {
  const { enabled = true } = options;
  
  return useQuery<UseDemandFiltersQueryResult>({
    queryKey: ['unified-demandas', 'filters'],
    queryFn: async () => {
      const [users, processos] = await Promise.all([
        apiService.getUsuarios(),
        apiService.getProcessosList(),
      ]);

      return {
        userOptions: buildUserOptions(users as User[]),
        processoOptions: buildProcessoOptions(processos as Processo[]),
      };
    },
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    retry: 1,
    enabled, // 🚀 Controla se a query deve ser executada
  });
};
